






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
	name: 'Hamburger'
})
/** Hamburger */
export default class Hamburger extends Vue {
	@Prop({
		default: false
	})
	private isActive!: boolean;

	/** 切换按钮 */
	private toggleClick(): any {
		this.$emit('toggle-click');
	}
}
